import { PersonalProfile } from 'app/core/types';

export const profileKeyMap: Record<string, keyof PersonalProfile> = {
	firstname: 'firstName',
	middle: 'middle',
	lastname: 'lastName',
	dateofbirth: 'dateOfBirth',
	address: 'address',
	city: 'city',
	state: 'state',
	zipcode: 'zipCode',
	country: 'country',
	phonecode: 'phoneCode',
	phonenumber: 'phoneNumber',
	email: 'email',

	// documents
	documenttype: 'documentType',
	identitycardfront: 'identityCardFront',
	identitycardback: 'identityCardBack',
	ssnnumber: 'ssnNumber',
	ssnfront: 'ssnFront',
	ssnback: 'ssnBack',
	bankname: 'bankName',
	bankaddress: 'bankAddress',
	bankaccount: 'bankAccount',
	bankconfirmaccount: 'bankConfirmAccount',
	bankroutingnumber: 'bankRoutingNumber',
	bankswiftcode: 'bankSwiftCode',
	utilitybillfront: 'utilityBillFront',
	voidcheckpersonalfront: 'voidCheckPersonalFront',
	voidcheckpersonalback: 'voidCheckPersonalBack',
	utilitybilltype: 'utilityBillType',
	selfie: 'selfie',
};
